import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import { useNotWorkingStyles } from './styles';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { validateDateFormat } from '../../../../../../../helpers/DateFormatter';

const NotWorking = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile } = props;
  const classes = useNotWorkingStyles({ mobile });
  const [date, setDate] = useState('');
  const [dateValidation, setDateValidation] = useState('');
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [motiveClient, setMotiveClient] = useState('');

  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const options = [
    'El producto no funciona',
    'El producto llegó roto',
    'Aparecieron inconvenientes después del uso',
  ];

  const handleOptions = (event) => {
    setMotiveClient(event.target.value);
  };

  const dateFormat = (e) => {
    const { value } = e.target;
    const isValid = validateDateFormat(value);

    setSuccess(isValid);
    setError(!isValid);
    setDateValidation(isValid ? 'valid' : 'error');
  };

  const sendData = () => {
    const dateReceiptProduct = date.split('/').reverse().join('-');

    const body = {
      fecha_recepcion_producto: dateReceiptProduct,
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        motiveClient: motiveClient,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <AppInput
        required
        name="dateInput"
        label="Fecha de recepción del producto"
        value={date}
        onClick={() => {}}
        onChange={handleDate}
        onBlur={dateFormat}
        success={success}
        errorMessage={'Formato de fecha incorrecto'}
        error={error}
        helperText={'DD/MM/AAAA'}
      />
      <Typography className={classes.titleChooseOption}>
        Elige una opción:
      </Typography>
      <RadioGroup onChange={handleOptions} value={motiveClient}>
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={option}
            label={option}
            control={<Radio color="primary" />}
            className={classes.radioButtons}
            data-cy={`radio${option.split(' ').join('')}`}
          />
        ))}
      </RadioGroup>
      <AuthorizeCheckbox
        idComplement="NotWorking"
        onCheck={() => setChecked(!checked)}
        disabled={motiveClient === '' || dateValidation !== 'valid'}
      />
      <LoadingButton
        name="NotWorking"
        text="Enviar"
        disabled={!checked || motiveClient === '' || dateValidation !== 'valid'}
        className={classes.sendButton}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        data-cy="NotWorking"
      />
    </Box>
  );
};

NotWorking.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
};

export default NotWorking;
